import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getProductsListThunk, searchProductsThunk } from './productListingThunk'

const initialState = {
	products: [],
	productsCount: 0,
	searchProducts: {
		searchKey: '',
		products: [],
		gameProducts: [],
		total: 0,
		productCount: 0,
		gameProductCount: 0,
	},
}

export const getProductsList = createAsyncThunk('website/getProductsList', getProductsListThunk)
export const searchProducts = createAsyncThunk('website/searchProducts', searchProductsThunk)

export const productListingSlice = createSlice({
	name: 'productsListing',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getProductsList.fulfilled, (state, action) => {
			state.products = action.payload?.data?.data
			state.productsCount = action.payload?.data?.total
		})
		builder.addCase(searchProducts.fulfilled, (state, action) => {
			state.searchProducts = action.payload?.data?.data
		})
	},
})
export default productListingSlice.reducer
